module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-solid-900-8618686494a5c8092120235c28400ed4.ttf";